<template>
  <div class="rounded-bottom-one"></div>
</template>